import { createSvgIcon } from '@mui/material/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var UserCheckIcon = createSvgIcon( /*#__PURE__*/_jsxs(_Fragment, {
  children: [/*#__PURE__*/_jsx("circle", {
    cx: "15",
    cy: "7.26",
    r: "4"
  }), /*#__PURE__*/_jsx("path", {
    d: "M15,13.26a8.07,8.07,0,0,0-8,6.93,1,1,0,0,0,1,1.15H22a1,1,0,0,0,1-1.15A8.07,8.07,0,0,0,15,13.26Z"
  }), /*#__PURE__*/_jsx("path", {
    d: "M4.41,11.81l-1.5-1.5a1,1,0,0,0-1.4,1.4L3.7,13.9a1,1,0,0,0,1.41,0l3.6-3.59a1,1,0,1,0-1.4-1.4Z"
  })]
}), 'UserCheckIcon');